import { useEffect } from 'react';

export const useScrollIntoErrors = (
  dependencies: any[],
  parentSelector?: string,
  block?: ScrollLogicalPosition,
): void => {
  useEffect(() => {
    const errorElement = parentSelector
      ? document.querySelector(`${parentSelector} .Mui-error, [data-error]`)
      : document.querySelector('.Mui-error, [data-error]');

    (errorElement?.parentElement ?? errorElement)?.scrollIntoView({
      behavior: 'smooth',
      block: block || 'center',
    });
  }, [...dependencies]);
};
